import React from 'react';
import PropTypes from 'prop-types';

import styles from './ActiveSubscriptionBanner.module.scss';

const ActiveSubscriptionBanner = ({ subscriptionsQty }) => (
  <div className={styles.activeSubscription}>
    <p>You have {subscriptionsQty} active subscription of this product</p>
    <a href="/my-box">View your subscriptions</a>
  </div>
);

ActiveSubscriptionBanner.propTypes = {
  subscriptionsQty: PropTypes.number.isRequired,
};

export default ActiveSubscriptionBanner;
